import { Component, OnInit } from '@angular/core';
import { DialogService, DialogComponent } from '../dialog';
import { PosService } from 'src/app/lazy/private/services/pos.service';
export interface RAModel {
  title: string;
  Items: any;
  type: number;
}
@Component({
  selector: 'app-rider-assign',
  templateUrl: './rider-assign.component.html',
  styleUrls: ['./rider-assign.component.css']
})
export class RiderAssignComponent extends DialogComponent<RAModel, boolean>
  implements RAModel, OnInit {
  title: string;
  Items: any;
  type: number;
  result: any = { result: false, RtnItem: {} };
  SOList: any;
  RList: any;
  riderModel;
  constructor(
    dialogService: DialogService,
    private pos: PosService
  ) {
    super(dialogService);
  }

  ngOnInit() {

    this.getRiders();
    if (this.type === 1) {
      this.getSalesOrders();
    } else if (this.type === 2) {
      // this.getSalesDelivery();
    }
  }
  getRiders() {
    this.pos.GetRidersByLoc({ LocationId: 1 })
      .subscribe(res => {
        this.RList = res.data;
      });
  }
  getSalesOrders() {
    this.pos.GetSalesOrderByStatus({
      Status: '2',
      LocationId: 1
    })
      .subscribe(res => {
        if (res.Success) {
          this.SOList = res.data;
        }
      });
  }
  getSalesDelivery(riderId) {
    this.pos.GetSalesOrderByStatus({
      Status: '3',
      LocationId: 1
    })
      .subscribe(res => {
        if (res.Success) {
          this.SOList = []
          for (let i of res.data) {
            if (i.RiderId == riderId) {
              this.SOList.push(i)
            }
          }
        }
      });
  }
  selectItem(i) {
    i.selected = !i.selected;
  }
  saveData() {
    if (this.type == 1) {
      this.saveAssign();
    } else if (this.type == 2) {
      this.saveDelivery();
    }
  }
  saveAssign() {
    if (this.riderModel == null || this.riderModel == 0) {
      alert('please select Rider');
      return;
    }
    if (confirm('Do you want to Assign selected Order(s)')) {
      const param = [];
      for (const i of this.SOList) {
        if (i.selected) {
          param.push({
            OrderNo: i.OrderNo,
            OrderStatus: 3,
            Area: '',
            RiderId: this.riderModel,
            IsSettled: false,
            ReferenceNo: i.ReferenceNo,
            LocId: i.LocId
          });
        }
      }
      this.pos.updateSalesOrderStatus(param)
        .subscribe(res => {
          if (res.Success) {
            for (let i of res.data) {
              this.pos.ecom_Status_Update(i.ReferenceNo, 'Rider', i.RiderName);
            }
            alert('Rider Assign Successfully');
            this.close();
          }
        });
    }
  }
  saveDelivery() {
    if (this.riderModel == null || this.riderModel == 0) {
      alert('please select Rider');
      return;
    }
    if (confirm('Do you want to Delivered selected Order(s)')) {
      const param = [];
      for (const i of this.SOList) {
        if (i.selected) {
          param.push({
            OrderNo: i.OrderNo,
            OrderStatus: 5,
            Area: '',
            RiderId: i.RiderId,
            IsSettled: true,
            ReferenceNo: i.ReferenceNo,
            LocId: i.LocId
          });
        }
      }
      this.pos.updateSalesOrderStatus(param)
        .subscribe(res => {
          if (res.Success) {
            // alert('Rider Assign Successfully');
            for (let i of res.data) {
              this.pos.ecom_Status_Update(i.ReferenceNo, 'Settled', i.RiderName);
            }
            alert('Delivered Successfully');
            this.close();
          }
        });
    }
  }
  changeData(e) {
    if (this.type == 2) {
      this.getSalesDelivery(e);
    }
  }
}
